import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DESTINATION_TYPE_DESTINATION } from '../../../../../../../../../components/SearchForm/components/DestinationField/models.js';
import { Card } from '../../../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/TopDestinations/components/Item/components/Card/index.js';
import { useDirectusImageUrl } from '../../../../../../../../../utils/directus.js';
export const Item = ({
  item,
  onSelectKeyword
}) => {
  const handleSelectTopDestination = () => {
    if (item.url) {
      window.open(item.url, item.target);
      return;
    }
    if (item.keyword) {
      onSelectKeyword({
        id: item.keyword,
        keyword: item.text,
        type: DESTINATION_TYPE_DESTINATION
      });
    }
  };
  const directusUrl = useDirectusImageUrl(`${item.image?.id}.${item.image?.extension}`);
  return _jsx(Card, {
    "data-testid": "top-destination",
    caption: item.text,
    image: directusUrl,
    onClick: handleSelectTopDestination
  });
};